import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import {WindowReload, WindowURL, WindowLocation} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validatefinancial} from './validate'


export default function OpenAccountStep5Financials(props) {

	function CallbackFunction(data){
		props.active(data);
	}
	 function CallbackState(data){
		 props.callstate(data);
	 }



	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [datenow, setdatenow] = useState('month/day/year ('+moment(new Date()).format('MM/DD/YYYY')+')');
	const [state,setstate] = useState({
		years_stock:props.state.years_stock,
		years_options:props.state.years_options,
		years_mutual:props.state.years_mutual,
		years_futures:props.state.years_futures,
		years_forex:props.state.years_forex,
		ave_stock:props.state.ave_stock,
		ave_options:props.state.ave_options,
		ave_mutual:props.state.ave_mutual,
		ave_futures:props.state.ave_futures,
		ave_forex:props.state.ave_forex,
		rate_stock:props.state.rate_stock,
		rate_options:props.state.rate_options,
		rate_mutual:props.state.rate_mutual,
		rate_futures:props.state.rate_futures,
		rate_forex:props.state.rate_forex,
		finance_annual:props.state.finance_annual,
		finance_marginal:props.state.finance_marginal,
		finance_totalnet:props.state.finance_totalnet,
		finance_liquidnet:props.state.finance_liquidnet,
		finance_sourceincome:props.state.finance_sourceincome,
		number_contracts:props.state.number_contracts,
		name_contracts:props.state.name_contracts,
		finance_amount:props.state.finance_amount,
		finance_fund:props.state.finance_fund,
		account_type:props.state.account_type,
		specify_finance_liquidnet:props.state.specify_finance_liquidnet,
		specify_finance_totalnet:props.state.specify_finance_totalnet,
		specify_finance_annual:props.state.specify_finance_annual,
	});

	function handleSubmitForm(values, props){

		let value = {
			years_stock:values.years_stock,
			years_options:values.years_options,
			years_mutual:values.years_mutual,
			years_futures:values.years_futures,
			years_forex:values.years_forex,
			ave_stock:values.ave_stock,
			ave_options:values.ave_options,
			ave_mutual:values.ave_mutual,
			ave_futures:values.ave_futures,
			ave_forex:values.ave_forex,
			rate_stock:values.rate_stock,
			rate_options:values.rate_options,
			rate_mutual:values.rate_mutual,
			rate_futures:values.rate_futures,
			rate_forex:values.rate_forex,
			finance_annual:values.finance_annual,
			finance_marginal:values.finance_marginal,
			finance_totalnet:values.finance_totalnet,
			finance_liquidnet:values.finance_liquidnet,
			finance_sourceincome:values.finance_sourceincome,
			number_contracts:values.number_contracts,
			name_contracts:values.name_contracts,
			finance_amount:values.finance_amount,
			finance_fund:values.finance_fund,
			specify_finance_liquidnet:values.specify_finance_liquidnet,
			specify_finance_totalnet:values.specify_finance_totalnet,
			specify_finance_annual:values.specify_finance_annual,
		}

		CallbackState(value);
		CallbackFunction(6);

	}



	/*-------------------------------------
		Queries
	--------------------------------------*/
	const [StocksNumYears, setStocksNumYears] = useState([]);
	const [AveTrading, setAveTrading] = useState([]);
	const [RateTrading, setRateTrading] = useState([]);
	const [ApproxTrading, setApproxTrading] = useState([]);
	const [NestedTrading, setNestedTrading] = useState([]);
	const [Approx2Trading, setApprox2Trading] = useState([]);
	const [SourceTrading, setSourceTrading] = useState([]);
	const [AssetsTrading, setAssetsTrading] = useState([]);

	function ApplicationQuries(){
		let formData = new FormData();
		formData.append('type','query_application');
		axios.post('/application/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setStocksNumYears(obj.StocksNumYears);
				setAveTrading(obj.AveTrading);
				setRateTrading(obj.RateTrading);
				setApproxTrading(obj.ApproxTrading);
				setNestedTrading(obj.NestedTrading);
				setApprox2Trading(obj.Approx2Trading);
				setSourceTrading(obj.SourceTrading);
				setAssetsTrading(obj.AssetsTrading);
		})
		.catch(function (error){
		});
	}


	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
			form: {
				financial: {
					title:'',
					content:'',
					message:'',
					total_network:'',
					liquid_network:'',
					applied:'',
					applied_number:'',
					applied_name:'',
					monies:'',
					monies_amount:'',
				},
				country: {
					title:'',
					content:'',
				}
			},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form: {
						financial: {
							title:obj.form.financial.title,
							content:obj.form.financial.content,
							message:obj.form.financial.message,
							total_network:obj.form.financial.total_network,
							liquid_network:obj.form.financial.liquid_network,
							applied:obj.form.financial.applied,
							applied_number:obj.form.financial.applied_number,
							applied_name:obj.form.financial.applied_name,
							monies:obj.form.financial.monies,
							monies_amount:obj.form.financial.monies_amount,
						},
						country: {
							title:obj.form.country.title,
							content:obj.form.country.content,
						}
					},
				});
		})
		.catch(function (error){
		});
	}

	useEffect(()=>{
		ApplicationQuries();
		ContentApplication();
	},[]);


	return (
		<React.Fragment>
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={validatefinancial}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
                   <h2>{content.form.financial.title}</h2>
									 {content.form.financial.content!=''?renderHTML(content.form.financial.content):''}
									 <Message visible negative>{content.form.financial.message}</Message>
                </div>

			            <div className="open-account-panel-body">
									<div className="application-box">
										<h3>Please let us know the number of years of experience for the following</h3>
										<div className="open-account-body-wrapper">
											<Form.Group widths="equal">
												<Field name="years_stock">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Stocks</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={StocksNumYears}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="years_options">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Options</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={StocksNumYears}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="years_mutual">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Mutual Funds</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={StocksNumYears}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="years_futures">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Futures</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={StocksNumYears}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="years_forex">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Forex</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={StocksNumYears}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
										</div>
									</div>{/*.account-body-wrapper*/}


									<div className="application-box">
										<h3>Average Trades Executed in a Month</h3>
										<div className="open-account-body-wrapper">
											<Form.Group widths="equal">
												<Field name="ave_stock">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Stocks</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={AveTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="ave_options">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Options</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={AveTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="ave_mutual">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Mutual Funds</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={AveTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="ave_futures">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Futures</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={AveTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="ave_forex">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Forex</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={AveTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>
										</div>
										</div>{/*.account-body-wrapper*/}


										<div className="application-box">
											<h3>Rate your trading knowledge</h3>
											<div className="open-account-body-wrapper">
												<Form.Group widths="equal">
													<Field name="rate_stock">
														{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Stocks</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={RateTrading}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="rate_options">
														{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Options</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={RateTrading}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="rate_mutual">
														{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Mutual Funds</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={RateTrading}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="rate_futures">
														{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Futures</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={RateTrading}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
												<Form.Group widths="equal">
													<Field name="rate_forex">
														{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<label>Forex</label>
																	<Select selectOnBlur={false}
																			{...field}
																			options={RateTrading}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
											</div>
										</div>{/*.account-body-wrapper*/}


									</div>{/*.panel-body*/}



									<div className="open-account-panel-body hasbodytop">
									<div className="application-box">
										<h3>Financial Information</h3>
										<div className="open-account-body-wrapper">
											<Form.Group widths="equal">
												<Field name="finance_annual">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Approximate Annual Income</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={ApproxTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>

											{/*values.finance_annual==1&&<Form.Group widths="equal">
												<Field name="specify_finance_annual">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label className="labelred">Specify Annual Income</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>*/}


											<Form.Group widths="equal">
												<Field name="finance_marginal">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Nested Marginal Bracket</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={NestedTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>


											<Form.Group widths="equal">
												<Field name="finance_totalnet">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Approximate Total Networth</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={Approx2Trading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>

											{/*values.finance_totalnet==1&&<Form.Group widths="equal">
												<Field name="specify_finance_totalnet">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label className="labelred">Specify Total Net Worth</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>*/}

											<Message warning visible>{content.form.financial.total_network}</Message>

											<Form.Group widths="equal">
												<Field name="finance_liquidnet">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Approximate Liquid Networth</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={Approx2Trading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>

											{/*values.finance_liquidnet==1&&<Form.Group widths="equal">
												<Field name="specify_finance_liquidnet">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label className="labelred">Specify Liquid Net Worth</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>*/}

											<Message warning visible>{content.form.financial.liquid_network}</Message>

											<Form.Group widths="equal">
												<Field name="finance_sourceincome">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>What is your source of income?</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={SourceTrading}
																		onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
											</Form.Group>

											<div className="labelform">{content.form.financial.applied}</div>
											<Form.Group widths="equal">
		                    <Field name="number_contracts">
		                        {({ field, form }) => (
		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>{content.form.financial.applied_number}</label>
		                          <Input {...field} onChange={handleChange}/>
		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		                        </Form.Field>
		                        )}
		                    </Field>
		                  </Form.Group>
											<Form.Group widths="equal">
		                    <Field name="name_contracts">
		                        {({ field, form }) => (
		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>{content.form.financial.applied_name}</label>
		                          <Input {...field} onChange={handleChange}/>
		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		                        </Form.Field>
		                        )}
		                    </Field>
		                  </Form.Group>

											<div className="labelform">{content.form.financial.monies}</div>
											<Form.Group widths="equal">
		                    <Field name="finance_amount">
		                        {({ field, form }) => (
		                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>{content.form.financial.monies_amount}</label>
		                          <Input {...field} onChange={handleChange}/>
		                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
		                        </Form.Field>
		                        )}
		                    </Field>
		                  </Form.Group>
										</div>

									</div>{/*.account-body-wrapper*/}

									<div className="application-box">
										<h3>How will you fund your account?</h3>
										<div className="open-account-body-wrapper">
										<Form.Group widths="equal">
											<Field name="finance_fund">
												{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>What is your source of income?</label>
															<Select selectOnBlur={false}
																	{...field}
																	options={AssetsTrading}
																	onChange={(e, { value }) => setFieldValue(field.name,value)}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
												)}
											</Field>
										</Form.Group>
										</div>
								</div>{/*.account-body-wrapper*/}



									</div>{/*.panel-body*/}


			            <div className="open-account-panel-footer">
									    <div className="account-panel-footer">
									    	<div><Button content='Back' className="primary" icon='left arrow' labelPosition='left' onClick={()=>CallbackFunction(values.account_type==1?41:42)}/></div>
                      	<div><Button content='Continue' className="primary" icon='right arrow' labelPosition='right' onClick={handleSubmit}/></div>
											</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
